/* eslint no-param-reassign: 0 */
import SkiRentalCartItem from '@/classes/SkiRentalCartItem';
import { refreshCart } from '@/store-methods/mutations/accomodation';

export const addRentalPeople = ($, payload) => {
  let i = 0;
  if (!payload.append) {
    $.cart.rentals = [];
  }

  $.cart.deliveryTo = payload.deliveryTo;

  while (i < payload.peopleCount) {
    const item = new SkiRentalCartItem();
    item.startDate = payload.pickedStartDate;
    item.days = payload.numberOfDays;
    item.delivery = payload.delivery;
    item.priceType = payload.priceType;

    $.cart.rentals.push(item);
    i += 1;
  }

  $.cart.currentRentalIndex = 0;
};

export const updateRentalPerson = ($, payload) => {
  const index = payload.index;

  if (payload.forceOverwrite || !payload.guideCompleted) {
    const item = $.cart.rentals[index];
    if (!item) {
      return;
    }
    item.name = payload.name;
    item.age = payload.age;
    item.category = payload.category;
    item.subCategory = payload.subCategory;
    item.type = payload.type;
    item.searchPackage = payload.searchPackage;
    item.startDate = payload.startDate;
    item.days = payload.days;
    item.priceType = payload.priceType;
  }
};

export const updateRentalPersonMeasurements = ($, payload) => {
  const index = payload.index;

  const item = $.cart.rentals[index];

  if (!item) {
    return;
  }

  item.lengthCm = payload.lengthCm;
  item.weight = payload.weight;
  item.shoeSize = payload.shoeSize;
  item.clothsize = payload.clothsize;

  item.skier = payload.skier;
};

export const updateRentalPersonSkier = ($, payload) => {
  const index = payload.index;

  const item = $.cart.rentals[index];

  if (!item) {
    return;
  }

  item.skier = payload.skier;
};

export const addProducts = ($, payload) => {
  const index = payload.index;
  const products = payload.products;

  const item = $.cart.rentals[index];
  item.quantity = 1;
  item.products = [];
  item.guideCompleted = true;

  products.forEach((product) => {
    item.products.push(product);
  });
};

export const setGuideCompleted = ($, payload) => {
  const index = payload.index;

  const item = $.cart.rentals[index];
  item.quantity = 1;
  item.guideCompleted = true;
};

export const completeGuides = ($) => {
  $.cart.rentals.forEach((rental) => {
    if (rental.age) {
      const sum = rental.products.reduce((b, product) => {
        const price = b + product.price;
        return price;
      }, 0) + rental.addons.reduce((b, product) => {
        const price = b + product.price;
        return price;
      }, 0);
      rental.guideFullyCompleted = true;
      rental.price = sum;
    }
  });
};

export const confirmRental = ($, payload) => {
  completeGuides($);
  $.cart.rentals.forEach((rental) => {
    rental.possibleAddons = [];
    if (rental.guideFullyCompleted) {
      rental.confirmed = true;
    }
    rental.site = payload.site;
    rental.pickupTime = payload.pickupTime;
    rental.phone = payload.phone;

    let key = '';
    const keyWithout = `price_${rental.days}`;
    const keyWithInsurance = `price_insurance_${rental.days}`;
    if (rental.insurance) {
      key = keyWithInsurance;
    } else {
      key = keyWithout;
    }

    if (rental.priceType && rental.priceType === 'night') {
      key = `${key}_night`;
    }

    if (!window.SITE_CONFIG.rental.insurance_per_product) {
      if (rental.products.length) {
        rental.insuranceSum = parseInt(rental.products[0][keyWithInsurance], 10)
          - parseInt(rental.products[0][keyWithout], 10);
      } else if (rental.addons.length) {
        rental.insuranceSum = parseInt(rental.addons[0][keyWithInsurance], 10)
          - parseInt(rental.addons[0][keyWithout], 10);
      } else {
        rental.insuranceSum = 0;
      }
    } else {
      rental.products.forEach((product, i) => {
        rental.products[i].price = parseInt(product[key], 10);
      });
      rental.addons.forEach((product, i) => {
        rental.addons[i].price = parseInt(product[key], 10);
      });
    }

    const sum = rental.products.reduce((b, product) => {
      const price = b + product.price;
      return price;
    }, 0) + rental.addons.reduce((b, product) => {
      const price = b + product.price;
      return price;
    }, 0);

    rental.price = sum;
  });

  refreshCart($);
};

export const addRentalAddon = ($, payload) => {
  const index = payload.index;
  const product = payload.product;

  const item = $.cart.rentals[index];
  item.addons.push(product);
};

export const removeRentalAddon = ($, payload) => {
  const index = payload.index;
  const product = payload.product;

  const item = $.cart.rentals[index];

  let theIndex = -1;
  item.addons.forEach((addon, i) => {
    if (addon.pool_lid === product.pool_lid) {
      theIndex = i;
    }
  });

  item.addons.splice(theIndex, 1);
};

export const setOnSite = ($) => {
  $.isOnSite = true;
};

export const setOffSite = ($) => {
  $.isOnSite = false;
};

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/rental.js